export const ActionTypes = {
  SET_Loader: 'services/c_suit-dashboard/set_loader',
  ADD_USER_KPI: 'services/c_suit-dashboard/add_user_kpi',
  UPDATE_USER_KPI_LIST_SORTING: 'services/c_suit-dashboard/update_user_kpi_list_sorting',
  DELETE_USER_KPI: 'services/c_suit-dashboard/delete_user_kpi',
  UPDATE_USER_KPI: 'services/c_suit-dashboard/update_user_kpi',
  FETCH_KPI_INFORMATION: 'services/c_suit-dashboard/fetch_kpi_information',
  FETCH_KPI_LIST: 'services/c_suit-dashboard/fetch_kpi_list',
  FETCH_ALL_KPI_BY_USER: 'services/c_suit-dashboard/fetch_all_kpi_by_user',
  FETCH_USER_KPI_LIST: 'services/c_suit-dashboard/fetch_user_kpi_list',
  SET_USER_KPI_LIST: 'services/c_suit-dashboard/set_user_kpi_list',
  SET_ALL_KPI_BY_USER: 'services/c_suit-dashboard/set_all_kpi_by_user',
  SET_KPI_INFORMATION: 'services/c_suit-dashboard/set_kpi_information',
  SET_KPI_LIST: 'services/c_suit-dashboard/set_kpi_list',
  SET_SITE_KPI_DASHBOARD: 'services/c_suit-dashboard/set_site_kpi_dashboard',
  SET_GLOBAL_KPI_DASHBOARD: 'services/c_suit-dashboard/set_global_kpi_dashboard',
  SET_KPI_DETAIL_DASHBOARD: 'services/c_suit-dashboard/set_kpi_detail_dashboard',
  SET_MAP_GLOBAL_DASHBOARD: 'services/c_suit-dashboard/set_map_global_dashboard',
  FETCH_SITE_KPI_DASHBOARD: 'services/c_suit-dashboard/fetch_site_kpi_dashboard',
  FETCH_KPI_DETAIL_DASHBOARD: 'services/c_suit-dashboard/fetch_kpi_detail_dashboard',
  FETCH_GLOBAL_KPI_DASHBOARD: 'services/c_suit-dashboard/fetch_global_kpi_dashboard',
  SET_GLOBAL_DASHBOARD_DATE_FILTER: 'services/c_suit-dashboard/set_global_dashboard_date_filter',
  SET_GLOBAL_ASSET_UTILIZATION: 'services/c_suit-dashboard/set_asset_utilization_global_dashboard',
  SET_SITE_ASSET_UTILIZATION: 'services/c_suit-dashboard/set_site_asset_utilization_global_dashboard',
  FETCH_C_SUITE_MAP_VIEW_GLOBAL_DASHBOARD: 'services/c_suit-dashboard/fetch_c_suite_map_view_global_dashboard',
  FETCH_ASSET_UTILIZATION_GLOBAL_DASHBOARD: 'services/c_suit-dashboard/fetch_asset_utilization_global_dashboard',
  SET_SITE_PERFORMANCE_DETAIL: 'services/c_suit-dashboard/set_site_performance_detail_global_dashboard',
  FETCH_SITE_PERFORMANCE_DETAIL: 'services/c_suit-dashboard/fetch_site_performance_detail_global_dashboard',
  FETCH_SITE_ASSET_UTILIZATION_GLOBAL_DASHBOARD:
    'services/c_suit-dashboard/fetch_site_asset_utilization_global_dashboard',
};

const fetchMapGlobalDashboard = ({ cSuitDateFilter, userEmail }) => ({
  cSuitDateFilter,
  userEmail,
  type: ActionTypes.FETCH_C_SUITE_MAP_VIEW_GLOBAL_DASHBOARD,
});
const fetchGlobalAssetUtilization = ({ cSuitDateFilter, userEmail }) => ({
  cSuitDateFilter,
  userEmail,
  type: ActionTypes.FETCH_ASSET_UTILIZATION_GLOBAL_DASHBOARD,
});
const fetchSiteAssetUtilization = ({ selectedSite, cSuitDateFilter, userEmail }) => ({
  selectedSite,
  cSuitDateFilter,
  userEmail,
  type: ActionTypes.FETCH_SITE_ASSET_UTILIZATION_GLOBAL_DASHBOARD,
});

const fetchSiteKpiDashboard = ({ selectedSite, cSuitDateFilter, userEmail, pageNo }) => ({
  selectedSite,
  userEmail,
  cSuitDateFilter,
  pageNo,
  type: ActionTypes.FETCH_SITE_KPI_DASHBOARD,
});
const setSiteKpiDashboard = ({ siteKpiDetailDashboard }) => ({
  siteKpiDetailDashboard,
  type: ActionTypes.SET_SITE_KPI_DASHBOARD,
});
const fetchGlobalKpiDashboard = ({ cSuitDateFilter, userEmail, pageNo }) => ({
  cSuitDateFilter,
  userEmail,
  pageNo,
  type: ActionTypes.FETCH_GLOBAL_KPI_DASHBOARD,
});

const setGlobalKpiDashboard = ({ globalKpiDashboard }) => ({
  globalKpiDashboard,
  type: ActionTypes.SET_GLOBAL_KPI_DASHBOARD,
});

const fetchKpiDetailDashboard = ({ cSuitDateFilter, selectedKpi, userEmail }) => ({
  cSuitDateFilter,
  userEmail,
  selectedKpi,
  type: ActionTypes.FETCH_KPI_DETAIL_DASHBOARD,
});

const setKpiDetailDashboard = ({ kpiDetailDashboard }) => ({
  kpiDetailDashboard,
  type: ActionTypes.SET_KPI_DETAIL_DASHBOARD,
});

const setGlobalDashboardFilter = ({ selectedDuration }) => {
  return {
    selectedDuration,
    type: ActionTypes.SET_GLOBAL_DASHBOARD_DATE_FILTER,
  };
};

const setMapGlobalDashboard = ({ mapGlobalDashboard }) => {
  return {
    mapGlobalDashboard,
    type: ActionTypes.SET_MAP_GLOBAL_DASHBOARD,
  };
};

const setLoader = ({ showLoader }) => {
  return {
    showLoader,
    type: ActionTypes.SET_Loader,
  };
};
const setGlobalAssetUtilization = ({ globalAssetUtilization }) => {
  return {
    globalAssetUtilization,
    type: ActionTypes.SET_GLOBAL_ASSET_UTILIZATION,
  };
};
const setSiteAssetUtilization = ({ siteAssetUtilization }) => {
  return {
    siteAssetUtilization,
    type: ActionTypes.SET_SITE_ASSET_UTILIZATION,
  };
};
const fetchSitePerformanceDetail = ({ cSuitDateFilter, selectedKpi, selectedSite }) => {
  return {
    cSuitDateFilter,
    selectedKpi,
    selectedSite,
    type: ActionTypes.FETCH_SITE_PERFORMANCE_DETAIL,
  };
};
const fetchKpiInformation = ({ selectedKpi, userEmail }) => {
  return {
    selectedKpi,
    userEmail,
    type: ActionTypes.FETCH_KPI_INFORMATION,
  };
};
const fetchKpiList = () => {
  return {
    type: ActionTypes.FETCH_KPI_LIST,
  };
};

const setKpiList = ({ kpiList }) => {
  return {
    kpiList,
    type: ActionTypes.SET_KPI_LIST,
  };
};

const setSelectedKpiDetail = ({ selectedKpiDetail }) => {
  return {
    selectedKpiDetail,
    type: ActionTypes.SET_KPI_INFORMATION,
  };
};
const setSitePerformanceDetail = ({ sitePerformanceDetail }) => {
  return {
    sitePerformanceDetail,
    type: ActionTypes.SET_SITE_PERFORMANCE_DETAIL,
  };
};
const addUserKpi = ({ kpi, callback }) => {
  return {
    kpi,
    callback,
    type: ActionTypes.ADD_USER_KPI,
  };
};
const fetchAllKpiByUser = ({ userEmail }) => {
  return {
    userEmail,
    type: ActionTypes.FETCH_ALL_KPI_BY_USER,
  };
};
const setAllKpiByUser = ({ allKpiByUser }) => {
  return {
    allKpiByUser,
    type: ActionTypes.SET_ALL_KPI_BY_USER,
  };
};
const fetchUserKpiList = ({ userEmail }) => {
  return {
    userEmail,
    type: ActionTypes.FETCH_USER_KPI_LIST,
  };
};
const setUserKpiList = ({ userKpiList }) => {
  return {
    userKpiList,
    type: ActionTypes.SET_USER_KPI_LIST,
  };
};
const updateUserKpiSorting = ({ userKpiList, userEmail }) => {
  return {
    userKpiList,
    userEmail,
    type: ActionTypes.UPDATE_USER_KPI_LIST_SORTING,
  };
};
const deleteUserKpi = ({ selectedKpi, userEmail }) => {
  return {
    selectedKpi,
    userEmail,
    type: ActionTypes.DELETE_USER_KPI,
  };
};
const updateUserKpi = ({ selectedKpi, userEmail }) => {
  return {
    selectedKpi,
    userEmail,
    type: ActionTypes.UPDATE_USER_KPI,
  };
};

export default {
  setLoader,
  fetchMapGlobalDashboard,
  fetchSiteKpiDashboard,
  fetchGlobalKpiDashboard,
  setGlobalDashboardFilter,
  setGlobalKpiDashboard,
  fetchKpiDetailDashboard,
  setKpiDetailDashboard,
  setMapGlobalDashboard,
  fetchGlobalAssetUtilization,
  fetchSiteAssetUtilization,
  setSiteKpiDashboard,
  setGlobalAssetUtilization,
  setSiteAssetUtilization,
  fetchSitePerformanceDetail,
  setSitePerformanceDetail,
  fetchKpiInformation,
  setSelectedKpiDetail,
  fetchKpiList,
  setKpiList,
  addUserKpi,
  fetchAllKpiByUser,
  setAllKpiByUser,
  fetchUserKpiList,
  setUserKpiList,
  updateUserKpiSorting,
  deleteUserKpi,
  updateUserKpi,
};
